import { Component, computed, input, output } from "@angular/core";
import { IUnitAggregatedSpecialConstraintData } from "src/models/units/special-constraints.model";
import { SergeantTitleComponent } from "../sergeant-title/sergeant-title.component";

@Component({
    selector: "key-info-special-constraints",
    templateUrl: "./key-info-special-constraints.component.html",
    styleUrl: "./key-info-special-constraints.component.scss",
    imports: [SergeantTitleComponent],
})
export class KeyInfoSpecialConstraintsComponent {
    expandDetailsClicked = output<void>();
    specialConstraints = input.required<IUnitAggregatedSpecialConstraintData>();

    protected constraintsText = computed(() => {
        let constraints = this.specialConstraints()
            ?.aggregatedSpecialConstraints.map((c) => c.constraint.name.toLowerCase())
            .join(", ");
        if (constraints?.length > 0) {
            constraints = constraints.charAt(0).toUpperCase() + constraints.slice(1);
        }
        return constraints;
    });

    protected onShowMoreSpecialConstraints(): void {
        this.expandDetailsClicked.emit();
    }
}
